import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TEST_VARIATION_B } from '../../experiments';
import inWebMobileExp from '../../experiments/mobileWeb';
import RankingUser from '../../RankingUser';
import VerifiedReviews from '../../VerifiedReviews';

const Summary = ({ starSummary = null, displayVerified = false }) => {
    const displayUserRanking = starSummary && !inWebMobileExp(TEST_VARIATION_B);

    if (!displayUserRanking && !displayVerified) {
        return null;
    }
    return (
        <div className={classNames('summary', { 'is-mobile-web-exp tbody-6': inWebMobileExp() })}>
            {displayUserRanking && <RankingUser starSummary={starSummary} />}
            {displayVerified && <VerifiedReviews />}
        </div>
    );
};

Summary.propTypes = {
    starSummary: PropTypes.object,
    displayVerified: PropTypes.bool,
};

export default Summary;
